<template>
	<div class="detail-content pdb-24">
	<div class="divider mgl-24 mgr-24"></div>
	<!-- learnnnnnnn start here -->
	<div class="pdt-24 pdl-24 pdr-24 mgb-4">
		<div class="t-color-title t-body3 l-spacing42 font-r">
				{{$t('87')}}
		</div>
	<div class="position-relative">
	<div class="dashed-line-vertical" :style="`${direction === 'ltr' ? 'left': 'right'}:${(learnProgressRate.course.standard*100)/100}% !important`"></div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-lectureRed t-helper font-r">{{$t('88')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-lectureRed t-subtitle1 l-spacing6 font-b mgr-4 ">
					{{ Math.round(learnProgressRate.course.mine)}}
				</div>
			<div class="t-color-lectureRed t-caption font-r">{{$t('89', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-1 mgb-12 bg-iconinactiveText">
			<div class="real-percentage bg-lectureRed h-6 " :style="`width:${Math.round(learnProgressRate.course.mine)}% !important;`"></div>
		</div>
	</div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-iconInactive t-helper font-r">{{$t('90')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-iconInactive t-subtitle2 l-spacing6 font-b mgr-4 ">
					{{ Math.round(learnProgressRate.course.average)}}
				</div>
				<div class="t-caption t-color-iconInactive font-r">{{$t('89', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-5 mgb-12 bg-iconinactiveText">
				<div class="real-percentage bg-iconInactive h-6" :style="`width:${Math.round(learnProgressRate.course.average)}% !important;`"></div>
		</div>
	</div>
	</div>
	<div class="standard-percentage-wrap" >
			<div v-if="(parseInt(learnProgressRate.course.standard*100)/100)<85" :style="`padding-left:${(learnProgressRate.course.standard*100)/100}% !important`" class="t-left position-relative t-helper standard-percentage l-spacing36 font-r">{{ $t('92',{str: learnProgressRate.course.standard ? parseInt(learnProgressRate.course.standard) : 0 }) }}</div>
			<div v-else class="t-right position-relative t-helper standard-percentage l-spacing36 font-r t-color-iconInactive">{{ $t('92',{str: learnProgressRate.course.standard ? parseInt(learnProgressRate.course.standard) : 0 }) }}</div>
			<!-- <div class="t-center position-relative t-helper standard-percentage l-spacing36 font-r" :style="`left:${(learnProgressRate.course.standard*100)/100}% !important`" >{{ $t('92',{str: learnProgressRate.course.standard ? parseInt(learnProgressRate.course.standard) : 0 }) }}</div> -->
	</div>    
	</div>
		<!--learn eend here -->
		
		<!--Exam start here-->
	<div class="pdt-24 pdl-24 pdr-24  mgb-4">
		<div class="t-color-title t-body3 l-spacing42 font-r">
				{{$t('93')}}
		</div>
	<div class="position-relative">
	<div class="dashed-line-vertical" :style="`${direction === 'ltr' ? 'left': 'right'}:${(learnProgressRate.exams.standard*100)/100}% !important`"></div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-lecturePurple t-helper font-r">{{$t('88')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-lecturePurple t-subtitle1 l-spacing6 font-b mgr-4 ">
						{{ Math.round(learnProgressRate.exams.mine) }}
				</div>
				<div class="t-color-lecturePurple t-caption font-r">{{$t('91', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-1 mgb-12 bg-iconinactiveText">
			<div class="real-percentage bg-lecturePurple h-6 " :style="`width:${Math.round(learnProgressRate.exams.mine)}% !important;`">
			</div>
		</div>
	</div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-iconInactive t-helper font-r">{{$t('90')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-iconInactive t-subtitle2 l-spacing6 font-b mgr-4 ">
					{{ Math.round(learnProgressRate.exams.average) }}
				</div>
				<div class="t-caption t-color-iconInactive font-r">{{$t('91', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-5 mgb-12 bg-iconinactiveText">
			<div class="real-percentage bg-iconInactive h-6" :style="`width:${Math.round(learnProgressRate.exams.average)}% !important;`"></div>
		</div>
	</div>
	</div>
	<div class="standard-percentage-wrap" >
		<div v-if="(parseInt(learnProgressRate.exams.standard*100)/100)<85" :style="`padding-left:${(learnProgressRate.exams.standard*100)/100}% !important`" class="t-left position-relative t-helper standard-percentage l-spacing36 font-r">{{ $t('98',{str: learnProgressRate.exams.standard ? parseInt(learnProgressRate.exams.standard) : 0 }) }}</div>
		<div v-else class="t-right position-relative t-helper standard-percentage l-spacing36 font-r">{{ $t('98',{str: learnProgressRate.exams.standard ? parseInt(learnProgressRate.exams.standard) : 0 }) }}</div>
		<!-- <div class="t-center position-relative t-helper standard-percentage l-spacing36 font-r" :style="`left:${(learnProgressRate.exams.standard*75)/100}% !important`" >{{ $t('98',{str: learnProgressRate.exams.standard ? parseInt(learnProgressRate.exams.standard) : 0 }) }}</div> -->
		<!-- <div class="t-center position-relative t-helper standard-percentage l-spacing36 font-r" :style="`left:${(learnProgressRate.exams.standard*75)/100}% !important`" >{{ $t('98',{str: learnProgressRate.exams.standard ? parseInt(learnProgressRate.exams.standard) : 0 }) }}</div> -->
		</div>
	<!-- <div class="position-relative t-helper standard-percentage l-spacing36 font-r t-color-iconInactive">
		{{ $t('98',{str: learnProgressRate.exams.standard ? parseInt(learnProgressRate.exams.standard) : 0 }) }}
	</div> -->
	</div>

	<!--Exam end here-->
<!--Misson start here-->
<div class="pdt-24 pdl-24 pdr-24  mgb-4">
	<div class="t-color-title t-body3 l-spacing42 font-r">
			{{$t('99')}}
	</div>
	<div class="position-relative">
	<div class="dashed-line-vertical" :style="`${direction === 'ltr' ? 'left': 'right'}:${(learnProgressRate.mission.standard*100)/100}% !important`"></div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-lectureYellow t-helper font-r">{{$t('88')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-lectureYellow t-subtitle1 l-spacing6 font-b mgr-4 ">
						{{ Math.round(learnProgressRate.mission.mine) }}
					</div>
				<div class="t-color-lectureYellow t-caption font-r">{{$t('91', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-1 mgb-12 bg-iconinactiveText">
			<div class="real-percentage bg-lectureYellow h-6 " :style="`width:${Math.round(learnProgressRate.mission.mine)}% !important;`">
			</div>
		</div>
	</div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-iconInactive t-helper font-r">{{$t('90')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-iconInactive t-subtitle2 l-spacing6 font-b mgr-4 ">
					{{ Math.round(learnProgressRate.mission.average) }}
				</div>
				<div class="t-caption t-color-iconInactive font-r">{{$t('91', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-5 mgb-12 bg-iconinactiveText">
				<div class="real-percentage bg-iconInactive h-6" :style="`width:${Math.round(learnProgressRate.mission.average)}% !important;`"></div>
		</div>
	</div>
	</div>
	<div class="standard-percentage-wrap" >
                <div v-if="(parseInt(learnProgressRate.mission.standard*100)/100)<85" :style="`padding-left:${(learnProgressRate.mission.standard*100)/100}% !important`" class="t-left position-relative t-helper standard-percentage l-spacing36 font-r">{{ $t('98',{str: learnProgressRate.mission.standard ? parseInt(learnProgressRate.mission.standard) : 0 }) }}</div>
                <div v-else class="t-right position-relative t-helper standard-percentage l-spacing36 font-r">{{ $t('98',{str: learnProgressRate.mission.standard ? parseInt(learnProgressRate.mission.standard) : 0 }) }}</div>
                <!-- <div class="t-center position-relative t-helper standard-percentage l-spacing36 font-r" :style="`left:${(learnProgressRate.mission.standard*75)/100}% !important`" >{{ $t('98',{str: learnProgressRate.mission.standard ? parseInt(learnProgressRate.mission.standard) : 0 }) }}</div> -->
            </div>
	<!-- <div class="position-relative t-helper standard-percentage l-spacing36 font-r t-color-iconInactive">
		{{ $t('98',{str: learnProgressRate.mission.standard ? parseInt(learnProgressRate.mission.standard) : 0 }) }}
	</div> -->
	</div>
	<!--Misson end here-->

	<!--Initiatives start here-->
	<div class="pdt-24 pdl-24 pdr-24  mgb-4">
	<div class="t-color-title t-body3 l-spacing42 font-r">
		{{$t('105')}}
	</div>
	<div class="position-relative">
	<div class="dashed-line-vertical" :style="`${direction === 'ltr' ? 'left': 'right'}:${(learnProgressRate.participation.standard*100)/100}% !important`"></div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-lectureAqua t-helper font-r">{{$t('88')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-lectureAqua t-subtitle1 l-spacing6 font-b mgr-4 ">
					{{ Math.round(learnProgressRate.participation.mine) }}
					</div>
				<div class="t-color-lectureAqua t-caption font-r">{{$t('3034', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-1 mgb-12 bg-iconinactiveText">
				<div class="real-percentage bg-lectureAqua h-6 " :style="`width:${Math.round(learnProgressRate.participation.mine)}% !important;`">
			</div>
		</div>
	</div>
	<div class="percentage-wrapper">
		<div class="d-flex justify-content-between align-items-center">
			<div class="t-color-iconInactive t-helper font-r">{{$t('90')}}</div>
			<div class="d-flex align-items-baseline">
				<div class="percent-number t-color-iconInactive t-subtitle2 l-spacing6 font-b mgr-4 ">
						{{ Math.round(learnProgressRate.participation.average) }}
				</div>
				<div class="t-caption t-color-iconInactive font-r">{{$t('3034', {str: ''})}}</div>
			</div>
		</div>
		<div class="h-2 position-relative total-percentage mgt-5 mgb-12 bg-iconinactiveText">
				<div class="real-percentage bg-iconInactive h-6" :style="`width:${Math.round(learnProgressRate.participation.average)}% !important;`"></div>
		</div>
	</div>
	</div>
	 <div class="standard-percentage-wrap" >
			<div v-if="(parseInt(learnProgressRate.participation.standard*100)/100)<70" :style="`padding-left:${(learnProgressRate.participation.standard*100)/100}% !important`" class="t-left position-relative t-helper standard-percentage l-spacing36 font-r">{{ $t('3035',{str: learnProgressRate.participation.standard ? parseInt(learnProgressRate.participation.standard) : 0 }) }}</div>
			<div v-else class="t-right position-relative t-helper standard-percentage l-spacing36 font-r">{{ $t('3035',{str: learnProgressRate.participation.standard ? parseInt(learnProgressRate.participation.standard) : 0 }) }}</div>
			<!-- <div class="t-center position-relative t-helper standard-percentage l-spacing36 font-r" :style="`left:${(learnProgressRate.participation.standard*75)/100}% !important`" >{{ $t('98',{str: learnProgressRate.participation.standard ? parseInt(learnProgressRate.participation.standard) : 0 }) }}</div> -->
		</div>
	<!-- <div class="position-relative t-helper standard-percentage l-spacing36 font-r t-color-iconInactive">
		{{ $t('98',{str: learnProgressRate.participation.standard ? parseInt(learnProgressRate.participation.standard) : 0 }) }} -->
	<!-- </div> -->
	</div>
	 <!--Initiatives end here-->
	</div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 그래프 컴포넌트(my learning list item graph component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
	props: ['degreeId', 'learnProgressRate'],
	data() {
		return {
			direction:"ltr"

		}
	},
	mounted() {
		this.direction = document.querySelector('html').getAttribute('dir');
	},
}
</script>
<style scoped>
  .bg-custom5{
				background-color: var(--Iconinactive);
  }
  .total-percentage{
	  background-color:var(--Iconinactive);
  }
  .opacity7{
	  opacity: 0.7;
  }
  .total-percentage .real-percentage{
	  position: absolute;
	  left: 0;
	  top:-3px;
	  border-radius:6px;
	  width: 237px;
  }
  html[dir="rtl"] .total-percentage .real-percentage{
	  right: 0;
  }
  .standard-percentage{
	  color: var(--Iconinactive);
  }
  
</style>